import { faCheck, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Breadcrumb, BreadcrumbItem, Button, ButtonDropdown, Card, CardBody, CardHeader, Col,
    Container, Form, FormGroup, Input, Label, Row
} from 'reactstrap';
import Swal from 'sweetalert2';
import { authActions, prefeituraAction } from '../_actions';
import NavBar from '../_components/navbar';
import { stringUtils } from '../_utils'

const PrefeituraEdit = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const [id, setId] = useState(0);

    const [isOpenDrop, setOpenDrop] = useState(false);
    const toggleDropDown = () => setOpenDrop(!isOpenDrop);

    useEffect(() => {
        if (params.id) {
            dispatch(prefeituraAction.getPrefeituraById(params.id, true));
            setId(params.id);
        } else {
            if (authActions.isGestor() == false) {
                navigate('/prefeituras/');
            }
        }
    }, [navigate, params.id]);

    const handleChange = prop => event => {
        const { dispatch } = props;
        dispatch(prefeituraAction.onChangeProps(prop, event));

    };


    const handleValidation = event => {

        var valid = true;
        var errors = '';

        if (props.prefeitura.nome === null || props.prefeitura.nome === '') {
            valid = false;
            errors += '<li style="float:left;">Informe um nome válido!</li><br>';
        }
        if (props.prefeitura.inscricao_estadual === null || props.prefeitura.inscricao_estadual === '') {
            valid = false;
            errors += '<li style="float:left;">Informe uma inscrição estadual!</li><br>';
        }

        if (!valid) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });

        }
        return valid;
    };

    const handleSubmit = event => {


        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                nome: props.prefeitura.nome,
                inscricao_estadual: props.prefeitura.inscricao_estadual
            };

            if (params.id) {
                dispatch(prefeituraAction.editPrefeituraInfo(params.id, payload, true));

            } else {
                dispatch(prefeituraAction.createPrefeitura(payload, true));
                dispatch(prefeituraAction.clear());
            }
        }
    };

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/prefeituras">Lista de Prefeituras</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Prefeitura {props.prefeitura.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={3} lg={4}>
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            id="nome"
                                            label="Nome"
                                            className="form-control"
                                            value={props.prefeitura.nome || ''}
                                            onInput={stringUtils.toInputUppercase}
                                            onChange={handleChange('nome')} />
                                    </FormGroup>
                                </Col>
                                <Col md={3} lg={3}>
                                    <FormGroup>
                                        <Label className="left" for="inscricao_estadual">Inscrição Estadual *</Label>
                                        <Input
                                            id="inscricao_estadual"
                                            label="Inscrição Estadual"
                                            type="text"
                                            value={stringUtils.onlyNumbers(props.prefeitura.inscricao_estadual) || ''}
                                            maxLength={3}
                                            onChange={handleChange('inscricao_estadual')}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <br />
                            <Row>
                                <Col className="left" md="3" lg="3">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex  justify-content-end" lg="12">
                                    <Button className="mr-1" variant="contained" color="secondary" component='a' href="/prefeituras">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                    <Button variant="contained" color="primary" type="submit" style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    {id > 0 &&
                                        <ButtonDropdown className="mr-1" isOpen={isOpenDrop} toggle={toggleDropDown}>
                                        </ButtonDropdown>
                                    }
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>

            
        </div>
    );
}


const mapStateToProps = (state) => {
    return state;
}

const connectedPrefeituraEditPage = connect(mapStateToProps, null, null, {
    pure: false
})(PrefeituraEdit);

export { connectedPrefeituraEditPage as PrefeituraEdit };
